/**
 * Lane CAMERA-PITCH experiment (user decision 10-11): while the player flies with qinggong the camera tilts up a
 * little (a flatter pitch, more sky and horizon), eased in and out. A pitch drag during the flight cancels it until
 * the player lands. Switched by the `flightTilt` setting (default on). No drawing; tested in Node.
 */

/** Degrees the camera flattens by in flight. */
export const FLIGHT_TILT = 6;
/** Height (world pixels) above which the player counts as flying. */
const AIRBORNE_Z = 20;
/** Ease rate (per second, exponential). */
const EASE = 3;

export class FlightTilt {
  /** The current offset (degrees, ≤ 0). */
  offset = 0;
  private overridden = false;

  /** The player dragged the pitch: drop the tilt until the next landing. */
  drag(): void {
    this.overridden = true;
  }

  /** `z`: the player's height (a flying mount flies high too); `on`: the setting. True if the offset changed. */
  step(dt: number, z: number, on: boolean): boolean {
    const flying = z > AIRBORNE_Z;
    if (!flying) this.overridden = false;
    const goal = on && flying && !this.overridden ? -FLIGHT_TILT : 0;
    const from = this.offset;
    const next = from + (goal - from) * (1 - Math.exp(-EASE * dt));
    this.offset = Math.abs(goal - next) < 0.01 ? goal : next;
    return this.offset !== from;
  }
}
